module.exports = __webpack_public_path__ + "static/11-18ec2a8d18963a64efe22b971d33a770.jpg";